import { render, staticRenderFns } from "./ClientOtherAffiliates.vue?vue&type=template&id=267a3270&"
import script from "./ClientOtherAffiliates.vue?vue&type=script&lang=js&"
export * from "./ClientOtherAffiliates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports